module.exports = __webpack_public_path__ + "img/ball_tank.a6ece34b.svg";